import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';
import {
  bigint,
  index,
  jsonb,
  pgEnum,
  pgTable,
  timestamp,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';

export const one_shot_kind = pgEnum('one_shot_kind', [
  'DUMP_TICKET',
  'CONVERSATION_WITH_CUSTOMER',
  'PHOTO_OF_ASSET',
]);

export const gpt_one_shot_completion = pgTable(
  'gpt_one_shot_completion',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    oneShotKind: one_shot_kind('oneShotKind').notNull(),
    rawRequest: jsonb('rawRequest').notNull(),
    rawResponse: jsonb('rawResponse'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
  },
  (table) => {
    return {
      createdAtTs_idx: index('gpt_one_shot_completion_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      raw_request: index('gpt_one_shot_completion_raw_request').using(
        'gin',
        table.rawRequest,
      ),
      tenantId_idx: index('gpt_one_shot_completion_tenantId_idx').on(
        table.tenantId,
      ),
      updatedAtTs_idx: index('gpt_one_shot_completion_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('gpt_one_shot_completion_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('gpt_one_shot_completion_versionNumber_idx').on(
        table.versionNumber,
      ),
    };
  },
);

export const gpt_one_shot_completion_history = pgTable(
  'gpt_one_shot_completion_history',
  {
    ...defaultHistoryFields.historyFieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    oneShotKind: one_shot_kind('oneShotKind'),
    rawRequest: jsonb('rawRequest'),
    rawResponse: jsonb('rawResponse'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
  },
);
